import { Box } from '@chakra-ui/react';
import { Mode } from 'src/types/crudTable';
import { ColumnFilter } from '../Filter/ColumnFilter';
import { BulkUpdateSelect } from './BulkUpdater';
import { useTableContext } from './useTableContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var HeadCellFooter = function HeadCellFooter(_ref) {
  var column = _ref.column,
      isDisabled = _ref.isDisabled;

  var _useTableContext = useTableContext(),
      mode = _useTableContext.mode;

  var columnMeta = column.columnDef.meta;
  var hasFilter = Boolean(column.getCanFilter() && (columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.filterVariant));
  var hasBulkUpdate = Boolean(columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.bulkUpdate);
  var Component = mode === Mode.VIEW && hasFilter ? ColumnFilter : hasBulkUpdate ? BulkUpdateSelect : null;

  if (!Component) {
    return null;
  }

  return /*#__PURE__*/_jsx(Box, {
    w: "full",
    e2eid: "CrudTable_HeadCellFooter_Box",
    children: /*#__PURE__*/_jsx(Component, {
      column: column,
      isDisabled: isDisabled,
      e2eid: "CrudTable_HeadCellFooter_Component"
    })
  });
};